import areaRange from './areaRange.json';
import basicArea from './basicArea.json';
import basicBar from './basicBar.json';
import basicColumn from './basicColumn.json';
import basicLine from './basicLine.json';
import combinationCharts from './combinationCharts.json';
import gaps from './gaps.json';
import legendPlacement from './legendPlacement.json';
import linearAxis from './linearAxis.json';
import lineWithDataLabels from './lineWithDataLabels.json';
import logarithmicAxis from './logarithmicAxis.json';
import logarithmicAxisComparison from './logarithmicAxisComparison.json';
import missingData from './missingData.json';
import negativeAxis from './negativeAxis.json';
import noGaps from './noGaps.json';
import percentageArea from './percentageArea.json';
import percentageColumn from './percentageColumn.json';
import stackedArea from './stackedArea.json';
import stackedColumn from './stackedColumn.json';
import thresholds from './thresholds.json';
import timeSeriesZoomable from './timeSeriesZoomable.json';
import tooltipCustomization from './tooltipCustomization.json';

export default [
  areaRange,
  basicArea,
  basicBar,
  basicColumn,
  basicLine,
  combinationCharts,
  gaps,
  legendPlacement,
  linearAxis,
  lineWithDataLabels,
  logarithmicAxis,
  logarithmicAxisComparison,
  missingData,
  negativeAxis,
  noGaps,
  percentageArea,
  percentageColumn,
  stackedArea,
  stackedColumn,
  thresholds,
  timeSeriesZoomable,
  tooltipCustomization,
];
